import { doNothing } from './do-nothing'

export const IS_SSR = typeof window === 'undefined'

/**
 * Some functions require `window` or other browser specific variables to work.
 * Those break in SSR environment.
 *
 * This function safely wraps those and only calls them on Client Side
 */
export const clientOnly = <T extends AnyFunction<void>>(cb: T): (...args: Parameters<T>) => void =>
  !IS_SSR ? cb : doNothing
